/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Dvc_Search_DuplicateInputs */

const en_task_dvc_search_duplicate = /** @type {(inputs: Task_Dvc_Search_DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This case already has a DVC request with this type and value.`)
};

const pt_br2_task_dvc_search_duplicate = /** @type {(inputs: Task_Dvc_Search_DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já existe uma solicitação de DVC com este tipo e este dado neste caso.`)
};

/**
* | output |
* | --- |
* | "This case already has a DVC request with this type and value." |
*
* @param {Task_Dvc_Search_DuplicateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_dvc_search_duplicate = /** @type {((inputs?: Task_Dvc_Search_DuplicateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Dvc_Search_DuplicateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_dvc_search_duplicate(inputs)
	return pt_br2_task_dvc_search_duplicate(inputs)
});